import TypesMenuDesktop from './TypesMenuDesktop';
import TypesMenuMobile from './TypesMenuMobile';
import { isMobile } from 'utils/isMobile';

export default isMobile ? TypesMenuMobile : TypesMenuDesktop;
